import { DeploymentSlot } from './types';
import { axiosClient } from '../axiosClient';

export const getDeploymentSlots = async () =>
  axiosClient.get<DeploymentSlot>('/deployments/slots');
